import {
  Button,
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogDescription,
  ResponsiveDialogFooter,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
  Toggle,
} from "@repo/ui";

interface ProductCategoryFilterProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  categories: string[];
  selectedCategories: Set<string>;
  onToggleCategory: (category: string) => void;
  onClear: () => void;
  onApply: () => void;
}

export function ProductCategoryFilter({
  open,
  onOpenChange,
  categories,
  selectedCategories,
  onToggleCategory,
  onClear,
  onApply,
}: ProductCategoryFilterProps) {
  return (
    <ResponsiveDialog open={open} onOpenChange={onOpenChange}>
      <ResponsiveDialogContent className="flex max-h-[85vh] flex-col">
        <ResponsiveDialogHeader className="shrink-0">
          <ResponsiveDialogTitle>Filter by Collection</ResponsiveDialogTitle>
          <ResponsiveDialogDescription>
            Select collections to filter products.
          </ResponsiveDialogDescription>
        </ResponsiveDialogHeader>
        <div className="flex min-h-0 flex-1 flex-wrap content-start gap-2 overflow-y-auto py-4">
          {categories.map((category) => (
            <Toggle
              key={category}
              pressed={selectedCategories.has(category)}
              onPressedChange={() => onToggleCategory(category)}
              variant="outline"
              className="data-[state=on]:bg-teal-50 data-[state=on]:text-teal-700 data-[state=on]:border-teal-300"
            >
              {category}
            </Toggle>
          ))}
        </div>
        <ResponsiveDialogFooter className="flex shrink-0 gap-3">
          <Button variant="outline" className="flex-1" onClick={onClear}>
            Clear All
          </Button>
          <Button className="flex-1" onClick={onApply}>
            Apply Filters
          </Button>
        </ResponsiveDialogFooter>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
}
